import { render } from "./widget_chat.vue?vue&type=template&id=6050285e&scoped=true"
import script from "./widget_chat.vue?vue&type=script&lang=js"
export * from "./widget_chat.vue?vue&type=script&lang=js"

import "./widget_chat.vue?vue&type=style&index=0&id=6050285e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6050285e"]])

export default __exports__